// frontend/src/components/Automations/suggestName.js
// Name fallback for the New-automation form: the backend requires a name, the
// operator shouldn't have to invent one — the first few words of the intent
// are a fine default. Code-point aware (Array.from), so a truncation can never
// split a surrogate pair into an invalid UTF-8 byte sequence at INSERT time.
export function suggestName(prompt) {
  const words = String(prompt || '').trim().split(/\s+/).filter(Boolean).slice(0, 6).join(' ');
  const cps = Array.from(words);
  return cps.length > 60 ? `${cps.slice(0, 57).join('').trimEnd()}…` : words;
}
